import angular from 'angular';
import '../shared.module';

const TEMPLATE = `
  <div class="cp-confirm-backdrop">
    <div
      class="cp-confirm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="cp-confirm-title"
      aria-describedby="cp-confirm-message"
    >
      <h4 class="cp-confirm__title" id="cp-confirm-title">{{ title }}</h4>
      <p class="cp-confirm__message" id="cp-confirm-message">{{ message }}</p>
      <div class="cp-confirm__actions">
        <cp-button variant="ghost" on-click="cancel()">{{ cancelLabel }}</cp-button>
        <cp-button variant="{{ tone }}" on-click="confirm()">{{ confirmLabel }}</cp-button>
      </div>
    </div>
  </div>
`;

class ConfirmService {
  constructor($q, $compile, $rootScope, $document) {
    this.$q = $q;
    this.$compile = $compile;
    this.$rootScope = $rootScope;
    this.$document = $document;
  }

  open(options = {}) {
    const deferred = this.$q.defer();
    const scope = this.$rootScope.$new(true);

    scope.title = options.title || 'Confirmar ação';
    scope.message = options.message || '';
    scope.confirmLabel = options.confirmLabel || 'Confirmar';
    scope.cancelLabel = options.cancelLabel || 'Cancelar';
    scope.tone = options.tone || 'primary';

    const close = () => {
      element.remove();
      scope.$destroy();
    };

    scope.confirm = () => {
      deferred.resolve(true);
      close();
    };

    scope.cancel = () => {
      deferred.resolve(false);
      close();
    };

    const element = this.$compile(TEMPLATE)(scope);
    this.$document.find('body').append(element);

    return deferred.promise;
  }

  whenConfirmed(options, action) {
    return this.open(options).then((confirmed) => (confirmed ? action() : null));
  }
}

ConfirmService.$inject = ['$q', '$compile', '$rootScope', '$document'];

angular.module('app.shared').service('ConfirmService', ConfirmService);

export default ConfirmService;
